import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47cacd9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Feedback & Support")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Help us improve DView", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-body" }, " Please follow the link and answer the pinned questions. ", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Go to questionnaire")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Do you have a question or encountered any issues?", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-body" }, " Don’t hesitate to contact the support team on Microsoft Teams, and we will help you out as quickly as possible. ", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Contact us on Microsoft Teams")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, { text: "" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "ion-padding"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3,
          _createVNode(_component_ion_button, {
            href: _ctx.feedbackUrl,
            onClick: _ctx.trackFeedbackEvent,
            target: "_blank",
            fill: "clear",
            class: "button-link"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createVNode(_component_ion_icon, { icon: _ctx.openOutline }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["href", "onClick"]),
          _hoisted_5,
          _hoisted_6,
          _createVNode(_component_ion_button, {
            href: _ctx.supportUrl,
            onClick: _ctx.trackSupportEvent,
            target: "_blank",
            fill: "clear",
            class: "button-link"
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createVNode(_component_ion_icon, { icon: _ctx.openOutline }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["href", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}